<span [ngSwitch]="runOrigin">
    <i *ngSwitchCase="'analysis'" class="icon-dku-nav_analysis universe-color analysis"></i>
    <i *ngSwitchDefault class="icon-dku-nav_notebook universe-color notebook"></i> 
</span>